import {
  Box,
  FormControl,
  FormLabel,
  IconButton,
  Input,
  Heading,
  HStack,
  SimpleGrid,
} from "@chakra-ui/react";
import { HiOutlinePlus, HiOutlineTrash } from "react-icons/hi";
import CodesetSelect from "../../CodesetSelect";
import UuidPreview from "../../UuidPreview";
import CurrencyAmountInput from "../../CurrencyAmountInput";
import RateAmountInput from "../../RateAmountInput";
import PartySelectById from "../../PartySelectById";
import { createEmptyBrokerage } from "../../utils/placementDefaults";

const BrokerageItemEditor = ({ brokerage, brokerageIndex, onUpdate, onRemove }) => {
  const updateField = (field, value) => {
    onUpdate(brokerageIndex, field, value);
  };

  return (
    <Box borderWidth="1px" borderRadius="md" p={4} mb={6} borderColor="gray.500">
      <UuidPreview uuid={brokerage.id} />

      <SimpleGrid columns={{ base: 1, md: 3 }} spacing={4} mb={4}>
        <FormControl>
          <FormLabel>Description</FormLabel>
          <Input
            value={brokerage.description || ""}
            onChange={(e) => updateField("description", e.target.value)}
          />
        </FormControl>

        <CodesetSelect
          label="Type"
          codesetCode="A84"
          value={brokerage.type ? { code: brokerage.type, description: "" } : null}
          onChange={(value) => updateField("type", value.code)}
        />

        <FormControl>
          <FormLabel>Class Code</FormLabel>
          <Input
            value={brokerage.classCode || ""}
            onChange={(e) => updateField("classCode", e.target.value)}
          />
        </FormControl>
      </SimpleGrid>

      <SimpleGrid columns={{ base: 1, md: 3 }} spacing={4} mb={4}>
        <RateAmountInput
          label="Percentage"
          value={brokerage.percentage}
          onChange={(value) => updateField("percentage", value)}
        />

        <CodesetSelect
          label="Basis"
          codesetCode="A86"
          value={brokerage.basis ? { code: brokerage.basis, description: "" } : null}
          onChange={(value) => updateField("basis", value.code)}
        />

        <CurrencyAmountInput
          label="Amount"
          value={brokerage.amount}
          onChange={(value) => updateField("amount", value)}
        />
      </SimpleGrid>

      <SimpleGrid columns={{ base: 1, md: 3 }} spacing={4} mb={4}>
        <CurrencyAmountInput
          label="Base Amount"
          value={brokerage.baseAmount}
          onChange={(value) => updateField("baseAmount", value)}
        />

        <PartySelectById
          label="Payable To Party"
          value={brokerage.payableToParty}
          onChange={(value) => updateField("payableToParty", value)}
        />

        <PartySelectById
          label="Payable By Party"
          value={brokerage.payableByParty}
          onChange={(value) => updateField("payableByParty", value)}
        />
      </SimpleGrid>

      <HStack justify="flex-end" mt={4}>
        <IconButton
          size="md"
          icon={<HiOutlineTrash />}
          aria-label="Delete Brokerage"
          onClick={() => onRemove(brokerageIndex)}
        />
      </HStack>
    </Box>
  );
};

const BrokerageEditor = ({ brokerages = [], onChange }) => {
  const updateBrokerage = (brokerageIndex, field, value) => {
    const updated = [...brokerages];
    updated[brokerageIndex] = {
      ...updated[brokerageIndex],
      [field]: value,
    };
    onChange(updated);
  };

  const addBrokerage = () => {
    onChange([...brokerages, createEmptyBrokerage()]);
  };

  const removeBrokerage = (brokerageIndex) => {
    const updated = [...brokerages];
    updated.splice(brokerageIndex, 1);
    onChange(updated);
  };

  return (
    <Box>
      <HStack alignItems="center" mb={4}>
        <Heading size="md">Brokerage</Heading>
        <IconButton
          icon={<HiOutlinePlus />}
          size="md"
          aria-label="Add Brokerage"
          onClick={addBrokerage}
        />
      </HStack>

      {brokerages.map((brokerage, brokerageIndex) => (
        <BrokerageItemEditor
          key={brokerage.id}
          brokerage={brokerage}
          brokerageIndex={brokerageIndex}
          onUpdate={updateBrokerage}
          onRemove={removeBrokerage}
        />
      ))}
    </Box>
  );
};

export default BrokerageEditor;
